import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';

export const usePageEnter = () => {
  // useLocation gives us access to the state passed via navigate()
  const location = useLocation();

  useEffect(() => {
    const pageEl = document.getElementById('page-content');

    // Read the direction the previous page passed via navigate(path, { state: { direction } })
    // If no direction was passed (e.g. first load), default to 'up'
    const direction = location.state?.direction ?? 'up';

    // If previous page exited 'up' (slid off top), this page should enter from the bottom
    // If previous page exited 'down' (slid off bottom), this page should enter from the top
    const yIn = direction === 'up' ? '100%' : '-100%';

    gsap.fromTo(
      pageEl,
      { y: yIn, opacity: 0 },   // start offscreen in the correct direction
      { y: 0, opacity: 1, duration: 0.55, ease: 'power3.out' }  // animate to normal position
    );
  }, []); // empty deps = only runs once after this page mounts
};